import { estabelecimento } from "../Estabelecimento/estabelecimento"
import { format, newPage, sentryError } from "../utils"
import template from "./sobre.hbs"

export const Sobre = () => {

    mixpanel.track("Abriu a página sobre", { "Estabelecimento": estabelecimento.fantasia });

    newPage({
        appbarTitle: 'Informações', id: 'sobre'
    })

    const descricao = estabelecimento.informarcao ? estabelecimento.informarcao : ''
    const email = estabelecimento.contato.email ? estabelecimento.contato.email : '#'
    const twitter = estabelecimento.contato.twitter ? estabelecimento.contato.twitter : '#'
    const facebook = estabelecimento.contato.facebook ? estabelecimento.contato.facebook : '#'
    const site = estabelecimento.contato.site ? estabelecimento.contato.site : '#'
    const instagram = estabelecimento.contato.instagram ? estabelecimento.contato.instagram : '#'
    const telefone = estabelecimento.contato.telefone ? estabelecimento.contato.telefone : '#'
    const logradouro = estabelecimento.endereco.logradouro ? estabelecimento.endereco.logradouro : ''
    const numero = estabelecimento.endereco.numero ? estabelecimento.endereco.numero : ''
    const bairro = estabelecimento.endereco.bairro ? estabelecimento.endereco.bairro : ''
    const cidade = estabelecimento.endereco.cidade ? estabelecimento.endereco.cidade : ''
    const estado = estabelecimento.endereco.estado ? estabelecimento.endereco.estado : ''
    const pedidominimo = estabelecimento.valorMinimoPedido ? format.money(estabelecimento.valorMinimoPedido) : ''
    const diadasemana = ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sábado']
    const horarios = []
    const freeDeliveryTax = estabelecimento.entregaGratis ? format.money(estabelecimento.entregaGratis) : ''

    // Garantir que todos os dias da semana apareçam
    const diasCompletos = {}
    for (let i = 0; i < 7; i++) {
        diasCompletos[i] = {
            dia: diadasemana[i],
            intervalos: [],
            hoje: i === new Date().getDay()
        }
    }

    console.log('estabelecimento.diasDelivery:', estabelecimento.diasDelivery)

    // Preencher com os dados do estabelecimento
    if (estabelecimento.diasDelivery && estabelecimento.diasDelivery.length > 0) {
        estabelecimento.diasDelivery.forEach((dia, index) => {
            console.log(`Dia ${index}:`, dia)
            const intervalos = []
            if (dia.Intervalos && dia.Intervalos.length > 0) {
                dia.Intervalos.forEach(intervalo => {
                    console.log('Intervalo:', intervalo)
                    const inicio = intervalo.StartTime ? intervalo.StartTime.slice(0, 5) : '00:00'
                    const fim = intervalo.EndTime ? intervalo.EndTime.slice(0, 5) : '00:00'
                    intervalos.push(`${inicio} - ${fim}`)
                })
                diasCompletos[dia.DiaDaSemana].intervalos = intervalos
            } else {
                diasCompletos[dia.DiaDaSemana].intervalos = ['Fechado']
            }
        })
    }

    // Converter para array
    for (let i = 0; i < 7; i++) {
        if (diasCompletos[i].intervalos.length === 0) {
            diasCompletos[i].intervalos = ['Fechado']
        }
        horarios.push(diasCompletos[i])
    }

    console.log('Horários finais processados:', horarios)

    console.log('Horários processados:', horarios)

    const bandeiras = {
        Visa: '/images/web/cartoes/visa.svg',
        Mastercard: '/images/web/cartoes/mastercard.svg',
        American_Express: '/images/web/cartoes/amex.svg',
        Sorocred: '/images/web/cartoes/sorocred.svg',
        Diners_Club: '/images/web/cartoes/dinersclub.svg',
        Elo: '/images/web/cartoes/elo.svg',
        Hipercard: '/images/web/cartoes/hypercard.svg',
        Aura: '/images/web/cartoes/aura.svg',
        Cabal: '/images/web/cartoes/cabal.svg',
        Outros: '/images/web/cartoes/outros.svg'
    }

    const metodosPagamento = []
    if (estabelecimento.pagamento && estabelecimento.pagamento.metodos) {
        estabelecimento.pagamento.metodos.forEach(item => {
            // Mapeamento de prefixos para nomes amigáveis
            const tiposPagamento = {
                "DIN": "Dinheiro",
                "PIX": "PIX",
                "PMPY": "PIX pelo app",
                "CMPY": "Cartão de Crédito pelo app",
                "CRDE": "Cartão de Débito",
                "CRCR": "Cartão de Crédito",
                "VALE": "Vale Refeição/Alimentação",
                "DIGITAL": "Carteira Digital",
                "DEPOSITO": "Depósito Bancário",
                "TRANSFERENCIA": "Transferência Bancária"
            }

            // Mapeamento de ícones para cada tipo de pagamento
            const iconsPagamento = {
                "DIN": "/images/pagamentos/dinheiro.svg",
                "PIX": "/images/pagamentos/pix.svg",
                "PMPY": "/images/pagamentos/pix.svg",
                "CMPY": "/images/pagamentos/credito.svg",
                "CRDE": "/images/pagamentos/debito.svg",
                "CRCR": "/images/pagamentos/credito.svg",
                "VALE": "/images/pagamentos/vale.svg",
                "DIGITAL": "/images/pagamentos/digital.svg",
                "DEPOSITO": "/images/pagamentos/bank.svg",
                "TRANSFERENCIA": "/images/pagamentos/bank.svg"
            }

            const tipoFormatado = tiposPagamento[item.Prefixo] || item.Prefixo
            const icone = iconsPagamento[item.Prefixo] || "/images/pagamentos/outros.svg"

            if (item.Prefixo == "DIN") {
                metodosPagamento.push({
                    tipo: tipoFormatado,
                    icone: icone,
                    simples: true
                })
            } else if (item.Prefixo == "PIX") {
                metodosPagamento.push({
                    tipo: tipoFormatado,
                    icone: icone,
                    simples: true
                })
            } else if (item.Prefixo == "CRDE" || item.Prefixo == "CRCR") {
                // Para cartões, mostrar as bandeiras se disponível
                if (item.Bandeiras && item.Bandeiras.length > 0) {
                    const bandeirasList = item.Bandeiras.map(bandeira => bandeira.Bandeira.Descricao).join(', ')
                    metodosPagamento.push({
                        tipo: tipoFormatado,
                        icone: icone,
                        detalhes: bandeirasList,
                        simples: false
                    })
                } else {
                    metodosPagamento.push({
                        tipo: tipoFormatado,
                        icone: icone,
                        simples: true
                    })
                }
            } else {
                // Para outros tipos de pagamento
                metodosPagamento.push({
                    tipo: tipoFormatado,
                    icone: icone,
                    simples: true
                })
            }
        })
    }

    select('.page-body').innerHTML = template({
        descricao, email, twitter, facebook, site, telefone, instagram,
        logradouro, numero, bairro, cidade, estado, horarios, metodosPagamento,
        pedidominimo, freeDeliveryTax
    })

    const tabs = selectAll("snap-tabs nav a")
    const section = select("snap-tabs section")
    const articles = selectAll("snap-tabs section article")
    const indicator = select(".tab-indicator")

    let currentTabIndex = 0

    // Função para atualizar o indicador visual da tab
    const updateIndicator = (index) => {
        if (indicator && tabs[index]) {
            const activeTab = tabs[index]
            const rect = activeTab.getBoundingClientRect()
            const navRect = activeTab.parentElement.getBoundingClientRect()
            const left = rect.left - navRect.left
            const width = rect.width

            indicator.style.transform = `translateX(${left}px)`
            indicator.style.width = `${width}px`
        }
    }

    // Função para atualizar tab ativa
    const updateActiveTab = (activeIndex) => {
        if (activeIndex === currentTabIndex && tabs[activeIndex]?.hasAttribute('active')) return
        currentTabIndex = activeIndex

        tabs.forEach((tab, index) => {
            tab.removeAttribute('active')
            if (index === activeIndex) {
                tab.setAttribute('active', '')
            }
        })

        updateIndicator(activeIndex)
    }

    const scrollToArticle = (index) => {
        if (!section || !articles[index]) return
        section.scrollTo({
            top: articles[index].offsetTop,
            behavior: 'smooth'
        })
    }

    // Inicializar primeira tab como ativa
    if (tabs && tabs.length > 0) {
        updateActiveTab(0)
        requestAnimationFrame(() => updateIndicator(0))
    }

    // Event listeners para cliques nas tabs
    tabs && tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()

            updateActiveTab(index)
            scrollToArticle(index)
        })
    })

    if (section && articles && articles.length > 0) {
        const observer = new IntersectionObserver((entries) => {
            const visible = entries.filter(entry => entry.isIntersecting)
            if (!visible.length) return

            const best = visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
            const index = Number(best.target.getAttribute('data-tab'))
            if (!Number.isNaN(index)) {
                updateActiveTab(index)
            }
        }, {
            root: section,
            threshold: [0.2, 0.4, 0.6, 0.8]
        })

        articles.forEach(article => observer.observe(article))
    }

    sobre.querySelector('.app-bar img').addEventListener('click', () => {
        // Cleanup se necessário
    })

    // Função global para abrir o mapa
    window.abrirMapa = () => {
        const endereco = `${logradouro}, ${numero}, ${bairro}, ${cidade} - ${estado}`
        const encodedAddress = encodeURIComponent(endereco)

        // Tenta abrir no Google Maps app primeiro, senão abre no navegador
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`
        const mobileUrl = `geo:0,0?q=${encodedAddress}`

        // Detecta se é mobile
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

        if (isMobile) {
            // Tenta abrir o app nativo primeiro
            window.location.href = mobileUrl
            // Fallback para o navegador após um pequeno delay
            setTimeout(() => {
                window.open(googleMapsUrl, '_blank')
            }, 500)
        } else {
            window.open(googleMapsUrl, '_blank')
        }
    }

    // Aplicar estilo vermelho para horários "Fechado"
    setTimeout(() => {
        const hoursSpans = document.querySelectorAll('.hours span')
        hoursSpans.forEach(span => {
            if (span.textContent.trim() === 'Fechado') {
                span.classList.add('closed')
            }
        })
    }, 100)
}